import {
  markChoiceAfterLangQuery,
  resolveQueryLangForDetection,
} from "@/lib/languagePolicy";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

/**
 * Single pass for ?lang=: persist intent per languagePolicy, apply on SPA navigations, strip query.
 */
export function LanguageUrlSync() {
  const { i18n } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const raw = searchParams.get("lang")?.trim();
    if (!raw) return;

    markChoiceAfterLangQuery(raw);

    const fromQuery = resolveQueryLangForDetection(raw);
    if (fromQuery !== undefined && i18n.isInitialized && i18n.language !== fromQuery) {
      void i18n.changeLanguage(fromQuery);
    }

    const next = new URLSearchParams(searchParams);
    next.delete("lang");
    setSearchParams(next, { replace: true });
  }, [searchParams, setSearchParams, i18n]);

  return null;
}
